import facebook from './providers/facebook'
import vk from './providers/vk'
import pinterest from './providers/pinterest'

export default {
    facebook,
    pinterest,
    vk
}
